/*
  Table Delete Link Controller

  EMITTED EVENTS
    update-success (document) Emitted when a DELETE request is successfully submitted, if event-details-type is set in data
      detail: {
        el:   the root element of this controller instance,
        type: the passed in detail type
      }
*/

import { createCustomEvent } from '../../shared/helpers';

export default class extends Controller {

  connect() {
    if (this.hasPrompt) {
      App.Helpers.listenToCustomEvent(document, 'delete-success', this.removeIfElementMatches.bind(this));
    } else {
      App.Helpers.addAjaxSuccessHandler(this.element, this.removeHandler.bind(this));
    }
  }

  removeIfElementMatches(event) {
    if (event.detail.el === this.element) this.removeHandler();
  }

  removeHandler() {
    this.hasEventDetailType ? this.emitRemoveEvent() : this.removeRow();
  }

  emitRemoveEvent() {
    document.dispatchEvent(createCustomEvent('update-success', this.element, { type: this.eventDetailType }));
  }

  removeRow() {
    this.element.closest('tr').remove();
  }

  //
  // GETTERS AND SETTERS
  //

  get hasPrompt() {
    return [true, 'true', 1, '1'].includes(this.data.get('has-prompt'));
  }

  get eventDetailType() {
    return this.data.get('event-detail-type');
  }

  get hasEventDetailType() {
    return this.data.has('event-detail-type');
  }
};



// WEBPACK FOOTER //
// ./app/javascript/stimulusControllers/shared/table-delete-link-controller.js